export default __webpack_public_path__ + "static/media/fundo.7c1db396.png";